import { useEffect,useState } from 'react';

import { UserGroup } from 'common/types/Entities';
import { sortByProp } from 'common/utils/SortArrayByPropName';

export const useSetReportCompanyNameValue = (userGroups: UserGroup[]): {
    companyValue: string
} => {
    const [companyValue, setCompanyValue] = useState<string>('');

    useEffect(() => {
        if(userGroups.length) {
            if(userGroups.length > 1) {
                const sortedUserGroupsList = sortByProp('name')(userGroups);
                setCompanyValue(sortedUserGroupsList[0].name);
            } else {
                setCompanyValue(userGroups[0].name);
            }
        }
    }, [userGroups.length]);

    return {
        companyValue
    };
};
